import { render, staticRenderFns } from "./changePayPwd.vue?vue&type=template&id=6450f349&scoped=true"
import script from "./changePayPwd.vue?vue&type=script&lang=js"
export * from "./changePayPwd.vue?vue&type=script&lang=js"
import style0 from "./changePayPwd.vue?vue&type=style&index=0&id=6450f349&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6450f349",
  null
  
)

export default component.exports